import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default function (data) {
    let name = data.author.pen_name || data.author.name
    let storyTitle = data.story.title

    let router = new Router({
        mode: 'history',
        base: process.env.NODE_ENV === 'production' ? `/stories/preview/${window.__uuid}` : '/',
        scrollBehavior() {
            return { x: 0, y: 0 }
        },
        routes: [
            {
                path: '/',
                component: require('./views/Home').default,
                name: 'home',
                meta: {
                    title() {
                        return `${storyTitle} by ${name}`
                    },
                    transitionName: `slide`
                },
            },
            {
                path: '/:section_number',
                component: require('./views/Reader').default,
                name: 'reader',
                meta: {
                    title(route) {
                        let section = data.preview.snapshot[parseInt(route.params.section_number) - 1]
                        let sectionTitle = (section && section.title) || ('Chapter' + route.params.section_number)

                        return `${storyTitle} - ${sectionTitle} - ${name}`
                    },
                    transitionName: `slide`
                }
            },
        ],
    })

    router.afterEach((to) => {
        Vue.nextTick(() => {
            document.title = to.meta.title(to)
        })
    })

    return router
}
